"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chartDataMatches = exports.optionsUpdateState = void 0;
const _ = __importStar(require("lodash"));
if (!Object.is) {
    Object.defineProperty(Object, 'is', {
        value: (x, y) => (x === y && (x !== 0 || 1 / x === 1 / y)) || (x !== x && y !== y)
    });
}
const optionsUpdateState = (_lhs, _rhs) => {
    const { width: lhsWidth, height: lhsHeight, ...lhs } = _lhs;
    const { width: rhsWidth, height: rhsHeight, ...rhs } = _rhs;
    let state = 'keep';
    if (lhsHeight !== rhsHeight || lhsWidth !== rhsWidth) {
        state = 'update';
    }
    if (Object.keys(lhs).length !== Object.keys(rhs).length) {
        return 'create';
    }
    for (const k of Object.keys(lhs)) {
        if (!Object.is(_.get(lhs, k), _.get(rhs, k))) {
            state = 'create';
            break;
        }
    }
    return state;
};
exports.optionsUpdateState = optionsUpdateState;
const chartDataMatches = (lhs, rhs) => {
    if (lhs.length !== rhs.length) {
        return false;
    }
    return lhs.every((lhsOneSeries, seriesIdx) => {
        const rhsOneSeries = rhs[seriesIdx];
        if (lhsOneSeries.length !== rhsOneSeries.length) {
            return false;
        }
        if (Array.isArray(lhsOneSeries)) {
            return lhsOneSeries.every((value, valueIdx) => value === rhsOneSeries[valueIdx]);
        }
        return false;
    });
};
exports.chartDataMatches = chartDataMatches;
//# sourceMappingURL=helpers.js.map